export default __webpack_public_path__ + "static/media/gc_and_sc.99c6fc76.jpg";